module.exports = __webpack_public_path__ + "static/media/skills_demo.c58ea4ff.png";